var _path, _path2, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgInstagramIcon = function SvgInstagramIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 64 64"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#instagram-icon_svg__a)",
    d: "m45.356 55.986-26.667.026c-5.866.005-10.67-4.79-10.677-10.656l-.025-26.667c-.006-5.867 4.789-10.67 10.656-10.677l26.666-.026c5.867-.005 10.67 4.79 10.678 10.656l.025 26.667c.007 5.868-4.79 10.672-10.656 10.677Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#instagram-icon_svg__b)",
    d: "m45.356 55.986-26.667.026c-5.866.005-10.67-4.79-10.677-10.656l-.025-26.667c-.006-5.867 4.789-10.67 10.656-10.677l26.666-.026c5.867-.005 10.67 4.79 10.678 10.656l.025 26.667c.007 5.868-4.79 10.672-10.656 10.677Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M32 41.333c-5.145 0-9.333-4.187-9.333-9.334 0-5.146 4.188-9.333 9.333-9.333 5.145 0 9.333 4.187 9.333 9.333 0 5.147-4.188 9.334-9.333 9.334Zm0-16a6.674 6.674 0 0 0-6.667 6.666A6.674 6.674 0 0 0 32 38.666a6.674 6.674 0 0 0 6.667-6.667A6.674 6.674 0 0 0 32 25.333ZM42 24a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M40 49.333H24c-5.145 0-9.333-4.187-9.333-9.334V24c0-5.146 4.188-9.333 9.333-9.333h16c5.145 0 9.333 4.187 9.333 9.333v16c0 5.147-4.188 9.334-9.333 9.334Zm-16-32a6.674 6.674 0 0 0-6.667 6.666v16A6.674 6.674 0 0 0 24 46.666h16a6.674 6.674 0 0 0 6.667-6.667V24A6.674 6.674 0 0 0 40 17.333H24Z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "instagram-icon_svg__a",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "translate(25.84 56.046) scale(59.8653)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328,
    stopColor: "#FF543F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.348,
    stopColor: "#FC5245"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.504,
    stopColor: "#E64771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.643,
    stopColor: "#D53E91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.761,
    stopColor: "#CC39A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.841,
    stopColor: "#C837AB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "instagram-icon_svg__b",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(39.7507 0 0 26.4859 15.715 7.387)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4168C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999,
    stopColor: "#4168C9",
    stopOpacity: 0
  })))));
};
export default SvgInstagramIcon;